import { Component, OnInit, ViewChild } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, map, merge } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from "ngx-spinner";
import { FormBuilder, FormGroup, Validators, FormControl, AbstractControl } from '@angular/forms';
import { UsuarioService } from 'src/app/data-access/usuario.service';
import { CarreraService } from 'src/app/data-access/carrera.service';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';



@Component({
  selector: 'app-perfil',
  templateUrl: './perfil.component.html',
  styles: [
  ]
})
export class PerfilComponent implements OnInit {
  forma: FormGroup;
  loading = false;
  submitted = false;
  returnUrl: string;
  enabled = false;
  Colegios;
  model;
  features;
  constructor(
    private formBuilder: FormBuilder,
    private usuarioService: UsuarioService,
    private activatedRoute: ActivatedRoute,
    private carreraService: CarreraService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private router: Router
  ) {
    this.iniciarForm();
   }


  iniciarForm() {
   this.forma = this.formBuilder.group({
    cuenta: ['', [Validators.required, Validators.pattern("^[0-9]*$")]],
    nombres: ['', [Validators.required, Validators.pattern(/^[a-zA-ZáéíóúAÉÍÓÚÑñ ]+$/)]],
    aPaterno: ['', [Validators.required, Validators.pattern(/^[a-zA-ZáéíóúAÉÍÓÚÑñ ]+$/)]],
    aMaterno: ['', Validators.pattern(/^[a-zA-ZáéíóúAÉÍÓÚÑñ ]+$/)],
    correo: ['', [Validators.required, Validators.email]],
    telefonoPersonal: ['', [Validators.required, Validators.pattern("^[0-9]*$"),
    Validators.minLength(10), Validators.maxLength(10)]],
    telefonoCasa: ['', [Validators.required, Validators.pattern("^[0-9]*$"),
    Validators.minLength(10), Validators.maxLength(10)]],
    //extension: ['', [Validators.pattern("^[0-9]*$"),Validators.minLength(1), Validators.maxLength(5)]],
    clave: ['', Validators.required],
    confirmaclave: ['', Validators.required],
    idCarrera: [0, [Validators.required]],
    semestre: [0, [Validators.required, Validators.pattern("^[1-9]*$"),
    Validators.minLength(1), Validators.maxLength(2)]],
    idUsuario: [0],
    //rolId: [0],
    //perfilId: [0],
    idRol: [0],
    activo: [true],
    //otro_colegio_nombre: ['']
  },
  { validator: this.passwordConfirming }
  );
    this.model = this.forma;
  }

  /**********Validador de contraseñas iguales ***********/
  passwordConfirming(c: AbstractControl): { invalid: boolean } {
    if (c.get('clave').value !== c.get('confirmaclave').value) {
        return {invalid: true};
    }
  }

  User;
  ngOnInit(): void {
    this.addCarreras();
    this.addPerfil();
  }  

  Carreras;
  addCarreras(){
    this.carreraService.getCarrera()
    .toPromise().then(data => {
        this.Carreras = data;
      });    
  }

  addPerfil(){
    this.User = this.usuarioService.getUser();
    //alert(this.User.idUsuario);
    this.usuarioService.getUsuarioById(this.User.idUsuario).toPromise()
      .then(data => {
        this.model = data;
        console.log(data);
        this.model.confirmaclave = this.model.clave;
      });
  }  

  guardar() {
    //console.log(this.forma.value);
    this.spinner.show();
    console.log(this.forma.value);
    this.usuarioService.updData(this.model.idUsuario, this.forma.value).subscribe(
      (res) => {
        this.spinner.hide();
        this.recargar();
      },
      (error) => {
        this.spinner.hide();
        this.toastr.error(error.error.message);
        console.log(error);
        /*
        if(error.error.result === 3 || error.error.result === 3)
        {
          this.spinner.hide();
          this.toastr.error(error.error.message);
        }
        console.log(error);
        */
      });
  }

  recargar() {
    //this.modal.dismissAll();
    //this.Usuario = this.usuarioService.getData();
    this.toastr.success('Se han actualizado tus datos.');
    //alert("La solicitud ha sido enviada");
    //this.router.navigate(['/']);
    //this.router.navigate(['./login']);
  }

  cancelar(){
    this.router.navigate(['/']);
  }

}

